import { toast } from "sonner";
import api from "./api";

const DB_NAME = "tsj_offline";
const STORE = "pending";

const openDb = () =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "id" });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

const tx = async (mode, fn) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(req ? req.result : undefined);
    t.onerror = () => reject(t.error);
  });
};

export const getPending = () => tx("readonly", (s) => s.getAll());

export const isNetworkError = (err) => !err.response;

const notify = async () => {
  const items = await getPending();
  window.dispatchEvent(new CustomEvent("offline-queue-changed", { detail: { count: items.length, items } }));
};

export const queueRequest = async ({ method, url, payload, label }) => {
  await tx("readwrite", (s) =>
    s.add({
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      method, url, payload, label,
      createdAt: new Date().toISOString(),
    })
  );
  await notify();
};

let syncing = false;
export const syncPending = async () => {
  if (syncing || !navigator.onLine) return;
  const items = await getPending();
  if (!items.length) return;
  syncing = true;
  let sent = 0;
  try {
    for (const item of items.sort((a, b) => a.createdAt.localeCompare(b.createdAt))) {
      try {
        await api.request({ method: item.method, url: item.url, data: item.payload });
        await tx("readwrite", (s) => s.delete(item.id));
        sent += 1;
      } catch (err) {
        if (isNetworkError(err)) break;
        await tx("readwrite", (s) => s.delete(item.id));
        toast.error(`Data tertunda "${item.label}" ditolak server dan dihapus dari antrean`);
      }
    }
  } finally {
    syncing = false;
  }
  await notify();
  if (sent > 0) {
    toast.success(`Sinkronisasi otomatis selesai — ${sent} data "Tertunda" terkirim ke server`);
    window.dispatchEvent(new CustomEvent("offline-synced", { detail: { sent } }));
  }
};

let deferredPrompt = null;
export const canInstall = () => !!deferredPrompt;
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const promptInstall = async () => {
  if (!deferredPrompt) return null;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  window.dispatchEvent(new CustomEvent("pwa-install-changed"));
  return outcome;
};

export const initOffline = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  }
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new CustomEvent("pwa-install-changed"));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    window.dispatchEvent(new CustomEvent("pwa-install-changed"));
    toast.success("Aplikasi berhasil dipasang di perangkat");
  });
  window.addEventListener("online", () => syncPending());
  setInterval(() => {
    if (navigator.onLine) syncPending();
  }, 30000);
  syncPending();
  notify();
};
